export const CUSTOM_PASSWORD_PATTERN = /^(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[^\w\s]).{6,}$/;
